import React from 'react'
import { NavNavLink, NavLink, useNavigate } from "react-router-dom";
import MainLogo from '../assets/images/logo.png';
import axios from 'axios';
import { useState, useEffect } from 'react';
import MegaMenuImg from '../assets/images/menu-bg.png';
import MenuImg from '../assets/images/menu-prod-img.jpg';
import MenuIcon from '../assets/images/menu-cat-bg.png';
import { ApiUrl, BaseUrl } from '../Component/utitls/config';
import blogIcon from '../assets/images/icons/blog.png';
import LoginIcon from '../assets/images/icons/login.png';
import CartIcon from '../assets/images/icons/shopping-cart.png';
import Cookies from 'js-cookie';
import { myPopup } from '../Component/utitls/LoginPopup';
import { Helmet } from 'react-helmet';
const HeaderMenu = () => {
    const navigate = useNavigate();
    const [isMobileMenu, setisMobileMenu] = useState(false);
    const [MainCategory, setMainCategory] = useState([]);
    const [AllCategory, setAllCategory] = useState([]);
    const [AllCartList, setAllCartList] = useState([]);
    const [MegaMenuOpen, setMegaMenuOpen] = useState(false);
    const [IsLogin, setIsLogin] = useState(false);
    const [isSticky, setIsSticky] = useState(false);
    const [SerchShow, setSerchShow] = useState(false);
    const [searchInput, setSearchInput] = useState('');
    const [searchError, setsearchError] = useState(false);
    const [selectedLanguage, setSelectedLanguage] = useState('');
    // *******************************
    const srcOP = {
        width: '300px',
        cursor: 'pointer',
        display: 'block',
    };
    useEffect(() => {
        const handleScroll = () => {
            const scrollPosition = window.scrollY;
            if (scrollPosition > 100) {
                setIsSticky(true);
            } else {
                setIsSticky(false);
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    // *******************************
    const hamburgerStyle = {
        fontSize: '30px',
        cursor: 'pointer',
        width: '0%',
    };
    const colseSt = {
        fontSize: '45px',
    };
    const open = {
        width: '100%',
    };
    const toggleMenu = () => {
        setisMobileMenu(!isMobileMenu);
    };
    const closeMenu = () => {
        setisMobileMenu(false);
    };
    useEffect(() => {
        axios.get(`${ApiUrl}/main-category-list-menu`)
            .then(response => {
                setMainCategory(response.data);
            })
            .catch(error => {
                console.error("Error fetching legislator data:", error);
            });
    }, []);
    useEffect(() => {
        axios.get(`${ApiUrl}/all-category-list-menu`)
            .then(response => {
                setAllCategory(response.data);
            })
            .catch(error => {
                console.error("Error fetching legislator data:", error);
            });
    }, []);
    useEffect(() => {
        let CustPhoNo = localStorage.getItem('CustomerPhoneNo');
        let CustSessionID = localStorage.getItem('sessionId');
        let UserData;
        if (CustPhoNo) {
            UserData = {
                UserPhoNo: CustPhoNo,
                UserSessionID: CustSessionID,
                UserLogin: '1',
            };
            setIsLogin(true);

        } else {
            UserData = {
                UserSessionID: CustSessionID,
                UserLogin: '0',
            };
        }
        const Apiurl1234 = `${ApiUrl}/user-cart-list`;
        axios.post(Apiurl1234, UserData)
            .then(response => {
                setAllCartList(response.data);
            })
            .catch(error => {
                console.error("Error fetching legislator data:", error);
            });
    }, []);
    function logpop() {
        myPopup.open("true");
    }
    function srhShow() {
        setSerchShow(!SerchShow);
    }
    function handleSearchForm() {
        if (searchInput != '') {
            localStorage.setItem('SearchString', searchInput);
            navigate('/search-result');
            window.location.reload();
        } else {
            setsearchError(true);
        }
    }
    const handleKeyPress = (e) => {
        setsearchError(false);
        if (e.key === 'Enter') {
            handleSearchForm();
        }
    };
    

    const languageChange = (event) => {
        const selectedValue = event.target.value;
        setSelectedLanguage(selectedValue);
        sessionStorage.setItem('selectedLanguage', selectedValue);
    };
    // useEffect(() => {
       
    // }, [setSelectedLanguage]);
    return (
        <>
            <Helmet>
                {/* <script defer type="text/javascript" src="//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit" rel="nofollow"/>
                <script type="text/javascript">
                    {`
                    function googleTranslateElementInit() {
                    new window.google.translate.TranslateElement({
                        pageLanguage: 'en',
                        includedLanguages: 'en,hi,mr',
                        layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
                    }, 'google_translate_element');
                    }
                `}
                </script> */}
            </Helmet>
            <header className="site-header" id="myHeader" style={{ background: isSticky ? '#fff' : 'transparent', position: isSticky ? 'fixed' : 'relative', top: 0, width: '100%', zIndex: 1000 }}>
                <div className="container-fluid p-0">
                    <div className="topNaviGationUpper">
                        <div>
                            <form className='d-flex serach-form'>
                                <input class="form-control me-2" type="search" placeholder="Search" aria-label="Search" value={searchInput} onChange={(e) => setSearchInput(e.target.value)} onKeyDown={handleKeyPress} />
                                <div onClick={handleSearchForm} class="btn-search" type="submit"><i class="fa-solid fa-magnifying-glass"></i></div>
                            </form>
                            {searchError && (
                                <span className="search-error">Please put some value</span>
                            )}
                        </div>
                        <div className="TopHeadercust">
                            <ul>
                                <li >
                                    <a href="https://yashodaseeds.com/blog">
                                        <img src={blogIcon} className="top-icons" /> Blog
                                    </a>
                                </li>
                                {!IsLogin ? (
                                    <li><NavLink className="MenuActive" to="#!" onClick={logpop}><img src={LoginIcon}
                                        className="top-icons" /> Login</NavLink></li>
                                ) : (
                                    <li><NavLink className="MenuActive" to="/dashboard"><img src={LoginIcon}
                                        className="top-icons"  /> Dashboard</NavLink></li>
                                )}

                                <li>
                                    <NavLink className="MenuActive" to="/cart"><img src={CartIcon} className="top-icons" /> Cart <span>{AllCartList.length}</span></NavLink>
                                </li>
                                <li class="d-block d-sm-none">
                                    <NavLink className="MenuActive" to="/crop-book"><i class="fa-solid fa-download" style={{color: "#bf9237"}}></i> Download Our Crop Book </NavLink>
                                </li>
                                
                                {/* <li className="lang-select">
                                    <select className="form-control form-select" onChange={languageChange}>
                                        <option value="en">EN</option>
                                        <option value="hi">HI</option>
                                        <option value="mr">MR</option>
                                    </select>
                                </li> */}
                            </ul>
                        </div>
                        <div class="module__btn module__btn-phone d-flex align-items-center TopHeadercust">
                            <span id="google_translate_element" class="langua"></span>
                        </div>
                    </div>
                    <div className="navigationWrap">
                        <div className="menuWrap">
                            <div className="logobox">
                                <NavLink to="/">
                                    <img className="whiteLogo" src={MainLogo} alt="" />
                                </NavLink>
                            </div>
                            <div className="navbarMain onlyDesktop">
                                <ul>
                                    <li><NavLink to="/about-us"> About</NavLink></li>
                                    <li>
                                        <div className="dropdownMain">
                                            <a to="#!" className="dropbtn">Products <i
                                                className="fa-solid fa-angle-down"></i></a>
                                            <div className="dropdownMain-content dropdown_menu-mega bg-grey">
                                                <div className="container-fluid p-0">
                                                    <div className="row">
                                                        <div className="col-lg-3">
                                                            <div className="menuheading">
                                                                <h3>Our Products</h3>
                                                                <p>Our range of research-backed, high-yield seeds are developed to meet the precise crop growth requirements of different agro-climatic zones across the country, thereby delivering the best results for farmers.</p>
                                                                <img className="menu-prod-img" src={MenuImg} />
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-9">
                                                            <div className="menuListing sub-heading">
                                                                <ul>
                                                                    {MainCategory.map((mainCat, index) => {
                                                                        return (
                                                                            <li key={index}>
                                                                                <NavLink to={`/category/${mainCat.CategorySlug}`} className="main-head-cat" onClick={closeMenu}>
                                                                                    <img src={MenuIcon} className="menu-cat-bg" />
                                                                                    <span className="cat-hd">{mainCat.ProductCategoryName}</span>
                                                                                    <span className="menu-catprod-img">
                                                                                        <img src={`${BaseUrl}/ProductCategory/${mainCat.ProductCategoryIcon}`} />
                                                                                    </span>
                                                                                </NavLink>

                                                                                <div className="cat-prodList">
                                                                                    {AllCategory.map((AllCat, index12) => {
                                                                                        if (mainCat.ID == AllCat.ProductCategoryParentID) {
                                                                                            return (
                                                                                                <NavLink key={index12} to={`/product-type/${AllCat.CategorySlug}`} onClick={closeMenu}> {AllCat.ProductCategoryName}</NavLink>
                                                                                            );
                                                                                        }
                                                                                    })}

                                                                                </div>
                                                                            </li>
                                                                        );
                                                                    })}
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <img src={MegaMenuImg} className="menu-bg" />
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li><NavLink to="/research"> Research</NavLink></li>
                                    <li><NavLink to="/infrastructure"> Infrastructure</NavLink></li>
                                    <li><NavLink to="/network"> Network</NavLink></li>
                                    <li><NavLink to="/store"> Store</NavLink></li>
                                    <li><NavLink to="/careers"> Careers</NavLink></li>
                                    {/*<li><NavLink to="/media"> Media</NavLink></li>*/}
                                    <li><NavLink to="/reach-us"> Reach Us</NavLink></li>

                                </ul>
                            </div>
                            <div className="onlyMobile">
                                {isMobileMenu && (
                                    <div id="Sidenav" className={`sidenav ${isMobileMenu ? 'open' : ''}`} style={isMobileMenu ? open : null}>
                                        <div className="mobileBoxLogo InsideSideBar">
                                            <NavLink to="/">
                                                <img alt="" src={MainLogo} />
                                            </NavLink>
                                        </div>
                                        <a href="#!" className="closebtn" style={colseSt} onClick={toggleMenu} >×</a>
                                        <div className="mobmenuList accordion">
                                            <ul className="accordion accordion-flush" id="accordionFlushExampleMobmenu">
                                                <li className="accordion-item"><NavLink to="/about-us" onClick={closeMenu}> About </NavLink></li>
                                                <li className="accordion-item">
                                                    {/* <h2 className="accordion-header" id="flush-headingOne"> */}
                                                    <button className="accordion-button collapsed" type="button"
                                                        data-bs-toggle="collapse" data-bs-target="#flush-collapseOne"
                                                        aria-expanded="false" aria-controls="flush-collapseOne">
                                                        Products
                                                    </button>
                                                    {/* </h2> */}
                                                    <div id="flush-collapseOne" className="accordion-collapse collapse"
                                                        aria-labelledby="flush-headingOne"
                                                        data-bs-parent="#accordionFlushExampleMobmenu">
                                                        <div className="accordion-body">
                                                            <ul className="menuprodlist-items">
                                                                {MainCategory.map(maiCat => (
                                                                    <li><NavLink to={`/category/${maiCat.CategorySlug}`} onClick={closeMenu}> {maiCat.ProductCategoryName} </NavLink></li>
                                                                ))}

                                                                {/* <li><a href="about.html#mission-vision">Vagetables Seeds</a></li> */}
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li className="accordion-item"><NavLink to="/research" onClick={closeMenu}> Research </NavLink></li>
                                                <li className="accordion-item"><NavLink to="/infrastructure" onClick={closeMenu}> Infrastructure </NavLink></li>
                                                <li className="accordion-item"><NavLink to="/network" onClick={closeMenu}> Network </NavLink></li>
                                                <li className="accordion-item"><NavLink to="/store" onClick={closeMenu}> Store </NavLink></li>
                                                <li className="accordion-item"><NavLink to="/careers" onClick={closeMenu}> Careers </NavLink></li>
                                                <li className="accordion-item"><a href="https://yashodaseeds.com/blog"> Blog </a></li>
                                                <li className="accordion-item"><NavLink to="/reach-us" onClick={closeMenu}> Reach Us </NavLink></li>
                                            </ul>
                                        </div>
                                    </div>
                                )}

                                <div className="sideNaviMob">
                                    <span className="hamburgers" style={hamburgerStyle} onClick={toggleMenu}>&#9776;</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        </>
    )
}

export default HeaderMenu